module.exports = __webpack_public_path__ + "img/9788995547267.1bf14b59.jpg";